import { CircleAlert, RotateCcw } from 'lucide-react';

export function Versao() {
  function reiniciarAplicacao() {
    // força recarregar do zero indo para a raiz
    window.location.href = "/";
  }

  return (
    <div className='content'>
        <div className='content-liveness'>
            <div className='header'></div>

            <div className='content-success'>
                <CircleAlert color='#363636' strokeWidth={2} size={150}/>
                <span>Versão desatualizada</span>

                <button
                  onClick={reiniciarAplicacao}
                  className="btn-reload"
                >
                  <RotateCcw size={18} />
                  Atualizar aplicação
                </button>
            </div>
        </div>
    </div>
  );
}